export default __webpack_public_path__ + "f7e617720cd38e576ff67d1b21eed54c.png";